// src/hooks/useUserLocation.js
import { useEffect, useState } from "react";
// src/hooks/useUserLocation.js

const useUserLocation = () => {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [locationError, setLocationError] = useState(null);

  useEffect(() => {
    const storedLocation = sessionStorage.getItem("userLocation");

    if (storedLocation) {
      const { latitude, longitude } = JSON.parse(storedLocation);
      setLatitude(latitude);
      setLongitude(longitude);
      return;
    }

    if (!navigator.geolocation) {
      setLocationError("Geolocation not supported");
      return;
    }

    const options = {
      enableHighAccuracy: true, // 🔥 Forces GPS/WiFi positioning if available
      timeout: 10000,
      maximumAge: 0,
    };

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        sessionStorage.setItem(
          "userLocation",
          JSON.stringify({ latitude, longitude })
        );
        setLatitude(latitude);
        setLongitude(longitude);
      },
      (error) => {
        console.error(error);
        setLocationError(error.message || "Error getting location");
      },
      options
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);

  return { latitude, longitude, locationError };
};

 


// const useUserLocation = () => {
//   const [latitude, setLatitude] = useState(null);
//   const [longitude, setLongitude] = useState(null);
//   const [locationError, setLocationError] = useState(null); 
//
//   useEffect(() => {
//     const storedLocation = sessionStorage.getItem("userLocation"); 
//
//     if (storedLocation) {
//       const { latitude, longitude } = JSON.parse(storedLocation);
//       setLatitude(latitude);
//       setLongitude(longitude);
//       return;
//     } 
//
//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const { latitude, longitude } = position.coords;
//         sessionStorage.setItem(
//           "userLocation",
//           JSON.stringify({ latitude, longitude })
//         );
//         setLatitude(latitude);
//         setLongitude(longitude);
//       },
//       (error) => {
//         setLocationError(error.message || "Error getting location");
//       }
//     );
//   }, []); 
//
//   return { latitude, longitude, locationError };
// }; 

 export default useUserLocation;
